import { textGray } from '@osmosis/tailwind-ui/styles/text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import { FormattedMessage } from 'react-intl';

import { ReactNode } from 'react';

type Props = {
  heading?: ReactNode;
  subheading?: ReactNode;
};

/**
 * AuthHeader.
 */
const AuthHeader = ({
  heading = (
    <FormattedMessage
      id="createSchoolAccount.heading"
      defaultMessage="The best learning experience possible."
    />
  ),

  subheading = (
    <FormattedMessage
      id="login.paragraph"
      defaultMessage="Osmosis empowers students with our comprehensive video library combined with powerful study tools."
    />
  ),
}: Props) => {
  return (
    <Box className={`mb-8`}>
      <H1
        className={`${textGray} text-center opacity-[0.8] mb-4 sm:text-2xl text-xl`}
      >
        {heading}
      </H1>
      <P
        className={`text-[16px] max-w-[400px] m-[auto] text-center ${textGray} opacity-[0.75]`}
      >
        {subheading}
      </P>
    </Box>
  );
};

export default AuthHeader;
